module.exports = __webpack_public_path__ + "static/media/Climbing.bbfc1b83.png";